/* eslint-disable import/prefer-default-export */
import { useCurrentUser, useFeatureFlags } from "../../../reducers/layoutReducer/selectors";

export const useCnamEnabled = () => {
  const currentUser = useCurrentUser();
  const featureFlags = useFeatureFlags();

  return featureFlags.cnamRegistration && currentUser.account.country === "US";
};
